<template>
  <div>
    <div style="height: 40px;display: flex;align-items: center">
      <span style="margin-right:5px">查询时间</span>
      <vxe-input type="date" v-model="timeBegin"></vxe-input>
      <span>~</span>
      <vxe-input type="date" v-model="timeEnd"></vxe-input>
      <Button type="primary" style="border-radius: 5px;margin-left:5px" @click="search">搜索</Button>
    </div>
    <vxe-table
        style="margin-top: 10px"
        class="table-style"
        stripe
        align="center"
        highlight-hover-row
        border="inner"
        :loading="loading"
        :data="hisData"
        height="400"
    >
      <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
      <vxe-table-column field="createTime" title="购买日期" show-overflow>
        <template slot-scope="{ row }">
          <span>{{ row.createTime | timeFormat }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="usedType" title="状态" show-overflow>
        <template slot-scope="{ row }">
          <span>{{ row.usedType | usedType }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="count" title="扩容船队" show-overflow>
        <template slot-scope="{ row }">
          <span>{{ row.usedType === 1 || row.usedType === 2 ? '+' + row.count : '-' + row.count }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
        background
        size="small"
        :current-page.sync="page"
        :page-size.sync="rows"
        :total="total"
        @page-change="change"
    ></vxe-pager>
    <div class="modal-footer add-btn-box">
      <Button type="primary" style="border-radius: 5px" @click="close">返回</Button>
    </div>
  </div>
</template>
<script>
import $api from "@/apiProvider";
import moment from "moment";
import {timeFormatDate} from "@/filters/time";

export default {
  props: ['userId'],
  data() {
    return {
      timeBegin: null,
      timeEnd: null,
      loading: false,
      hisData: [],
      page: 1,
      rows: 10,
      total: 100
    }
  },
  filters: {
    usedType(val) {
      if (val === 1) {
        return "购买";
      } else if (val === 2) {
        return "新增";
      } else if (val === 3) {
        return "退款";
      } else if (val === 4) {
        return "查询";
      } else if (val === 5) {
        return "过期";
      } else if (val === 6) {
        return "删除";
      }
    },
  },
  mounted() {
    this.queryUsesTrackRecord();
  },
  methods: {
    change(val) {
      this.page = val.currentPage;
      this.rows = val.pageSize;
      this.queryUsesTrackRecord();
    },
    onChange(value) {
      if (value === 0) {
        this.queryUsesTrackRecord();
      }
    },
    close() {
      this.$emit('close');
    },
    search() {
      this.page = 1;
      this.queryUsesTrackRecord();
    },
    async queryUsesTrackRecord() {
      this.loading = true;
      let timeBegin = null;
      let timeEnd = null;
      timeBegin = this.timeBegin ? this.$utils.timestamp(moment(this.timeBegin).valueOf()) : null;
      timeEnd = this.timeEnd ? this.$utils.timestamp(moment(this.timeEnd).valueOf()) + 86399999 : null;
      let res = await $api.seachart.request("queryUsesTrackRecord", {
        userId: this.userId,
        timeBegin: timeBegin,
        timeEnd: timeEnd,
        page: this.page,
        rows: this.rows,
        recordType: 2
      });
      this.loading = false;
      if (res.code === 1) {
        res.data.list.map(i => {
          i.beginTime = timeFormatDate(i.beginTime);
          i.endTime = timeFormatDate(i.endTime);
        })
        this.total = res.data.total;
        this.hisData = res.data.list;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    }
  }
}
</script>
<style>
.modal-footer {
  box-sizing: border-box;
  padding: 10px 0;
  display: flex;
  justify-content: flex-end;
  width: 94%;
  position: absolute;
  bottom: 0;
}
</style>